import { CampaignSourceEnum, CampaignTypeEnum } from "@ecologi/shared";

export const SupportedCampaignEntriesTypes = [
  CampaignTypeEnum.PEPPA_PIG,
] as const;

export const campaignTypeToSourceMap: {
  [index in (typeof SupportedCampaignEntriesTypes)[number]]: CampaignSourceEnum;
} = {
  [CampaignTypeEnum.PEPPA_PIG]: CampaignSourceEnum.PEPPA_PIG,
};
